import { render, staticRenderFns } from "./userRegion.vue?vue&type=template&id=75baa1ad&scoped=true"
import script from "./userRegion.vue?vue&type=script&lang=js"
export * from "./userRegion.vue?vue&type=script&lang=js"
import style0 from "./userRegion.vue?vue&type=style&index=0&id=75baa1ad&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75baa1ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75baa1ad')) {
      api.createRecord('75baa1ad', component.options)
    } else {
      api.reload('75baa1ad', component.options)
    }
    module.hot.accept("./userRegion.vue?vue&type=template&id=75baa1ad&scoped=true", function () {
      api.rerender('75baa1ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistic/user/components/userRegion.vue"
export default component.exports